/*
 * @Author: wp
 * @Date: 2023-01-04 11:05:59
 * @Descripttion:
 */
export default ({ app }) => {
    app.router.beforeEach((to, from, next) => {
        const title = to.meta && to.meta.title
        if (title) {
            // document.title = title;
        }
        next()
    })
}
